import { getMarketToday } from '@/utils/format-date'

export { formatDateForApi, formatDateYMD, formatDateAsLocalIso } from '@/utils/format-date'

/**
 * "Today" for a PICKUP window — the US market's today, not the browser's (see getMarketToday). Every caller
 * of this is a pickup seed or a past-date snap, and a pickup date is a US date: a dispatcher in Tashkent
 * whose clock already reads Sep 1 must still be able to search Aug 31, which is what Los Angeles is on.
 * For "is this timestamp today in MY timezone" (row age, relative labels) format in the caller's own zone.
 */
export const getToday = (): Date => getMarketToday()
